<template>
  <div class="app-main-content fba-order">
    <order-grid v-show="view==='list'" ref="orderGrid" view-source="fbaOrder" config-module="101" @rowDoubleClicked="toLook()">
      <div slot="operations">
        <el-button no="look" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
        <el-button v-if="$checkPermission(['button_FBAOrder_editFbaBookingOrders'])" no="edit" type="success" @click="toEdit()">{{ $t('common.btn.edit') }}</el-button>
        <el-button v-if="$checkPermission(['button_FBAOrder_newFbaBookingOrders'])" no="Clone" type="primary" @click="toCopy()">{{ $t('SeaExport.Clone') }}</el-button>
        <el-button v-if="$checkPermission(['button_FBAOrder_newFbaBookingOrders'])" no="Add" type="primary" @click="toAdd()">{{ $t('FbaChannel.addOrder') }}</el-button>
        <el-dropdown
          v-if="$checkPermission(['button_FBAOrder_newFbaBookingOrders'])"
          style="margin:0 5px"
        >
          <el-button type="primary">
            {{ $t('CargoMsg.Cargo_Import_OnOrder') }}
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown" style="width: 144px">
            <!--  批量导入订单-->
            <el-dropdown-item>
              <el-upload
                ref="uploadOrderSingle"
                :action="URL.seaExport.batchImportFbaJob"
                :headers="headers"
                :show-file-list="false"
                accept=".xls, .xlsx"
                :before-upload="beforeOrderUpload"
                :on-success="uploadOrderSuccessBatch"
                :on-error="handleError"
                :data="{deptId:Number(curDepId),fileIdx :'',branchId :curOfficeId, lob: 'FBA'}"
                style="display: inline-block"
              >
                <el-button
                  slot="trigger"
                  type="text"
                  style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 130px;word-break: break-all; white-space: normal;"
                >
                  <span>
                    <img src="@/assets/fba-import.png">
                  </span>
                  {{ $t('FbaJob.batchImportOrder') }}
                </el-button>
              </el-upload>
            </el-dropdown-item>
            <!--  下载批量导入模板-->
            <el-dropdown-item>
              <el-button
                type="text"
                style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 130px;word-break: break-all; white-space: normal;"
                @click="downloadBatchTemplateSingle()"
              >
                <span>
                  <img src="@/assets/fba-download.png">
                </span>
                {{ $t('FbaJob.downloadBatchImportTemplate') }}
              </el-button>
            </el-dropdown-item>
            <!-- 导入单个FBA订单 -->
            <el-dropdown-item divided>
              <el-upload
                ref="uploadOrderSingle"
                :action="URL.fba.singleImport"
                :headers="headers"
                :show-file-list="false"
                accept=".xls, .xlsx"
                :before-upload="beforeOrderUpload"
                :on-success="uploadOrderSuccessSingle"
                :on-error="handleError"
                :data="{deptId:Number(curDepId),fileIdx :'',officeId :curOfficeId}"
                style="display: inline-block"
              >
                <el-button
                  slot="trigger"
                  type="text"
                  style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 130px;word-break: break-all; white-space: normal;"
                >
                  <span>
                    <img src="@/assets/fba-import.png">
                  </span>
                  {{ $t('FbaJob.importSingleOrder') }}
                </el-button>
              </el-upload>
            </el-dropdown-item>
            <!--下载单个导入FBA模板 -->
            <el-dropdown-item>
              <el-button
                type="text"
                style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 130px;word-break: break-all; white-space: normal;"
                @click="downloadTemplateSingle()"
              >
                <span>
                  <img src="@/assets/fba-download.png">
                </span>
                {{ $t('FbaJob.downloadSingleImportTemplate') }}
              </el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-if="$checkPermission(['button_FBAOrder_notSubmitFbaBookingOrder'])" no="notSubmit" type="primary" @click="toNotSubmit()">{{ $t('CargoMsg.Cargo_HoldSubmission') }}</el-button>
        <el-button v-if="$checkPermission(['button_FBAOrder_submitFbaBookingOrder'])" no="submit" type="primary" @click="toSubmit()">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
        <el-button v-if="$checkPermission(['button_FBAOrder_deleteFbaBookingOrder'])" no="Delete" type="danger" @click="toDelete()">{{ $t('SeaExport.Delete') }}</el-button>
      </div>
    </order-grid>
    <order-workspace v-show="view==='detail'" ref="orderWorkspace" :parent-context="context" view-source="fbaOrder" @back="backToList" @copy="toCopy" @notSubmit="toNotSubmit" @submit="toSubmit" />
    <job-copy-window :visible.sync="copyDialog.visible" lob="fba" @confirmCallBack="doCopyJob" />
  </div>
</template>

<script>
import orderGrid from './Order/orderGrid'
import orderWorkspace from './Order/orderWorkspace'
import CargoSimpleUpload from '@/components/Cargo/Common/CargoSimpleUpload'
import { cacheName, cache } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { doCopyFbaJob, updNotSubmitOrSubmit, fbaBatchRemove } from '@/api/Fba/fbaJob'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { isContractExpiredForbidCreateJob } from '@/api/seaExport/seaExportJob'
import LocalStorageUtils from '@/utils/localStorageUtils'
import JobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'

export default {
  name: 'FBAOrder',
  components: { orderGrid, orderWorkspace, CargoSimpleUpload, JobCopyWindow },
  data() {
    return {
      FbaJobConstants,
      view: 'list',
      loading: null,
      context: {},
      URL,
      copyDialog: {
        visible: false,
        job: {}
      },
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      exportOrderCommand: '导入下单'
    }
  },
  computed: {
    curDepId() {
      return this.$store.getters.currentDeptId
    },
    curOfficeId() {
      return this.$store.getters.currentOfficeId
    }

  },
  async created() {
    await cache.load(cacheName.USER, cacheName.OFFICE_LIST, cacheName.OFFICE, cacheName.CONFIG)
    this.context.user = cache.user
    this.context.officeList = cache.officeList
    this.context.office = cache.office
    this.context.config = cache.config
  },
  methods: {
    toLook() {
      const row = this.$refs.orderGrid.selectedItem
      this.detailHandle('look', row)
    },
    toEdit() {
      const row = this.$refs.orderGrid.selectedItem
      let checkMsg = ''
      if (row.submitState && row.submitState === FbaJobConstants.SUBMIT_STATE_SUBMITTED.code) {
        if (row.verifyState === FbaJobConstants.VERIFY_STATE_PENDING.code) {
          checkMsg = FbaJobConstants.VERIFY_STATE_PENDING.chineseName
        } else if (row.verifyState === FbaJobConstants.VERIFY_STATE_APPROVED.code) {
          checkMsg = FbaJobConstants.VERIFY_STATE_APPROVED.chineseName
        } else if (row.verifyState === FbaJobConstants.VERIFY_STATE_REVIEWED.code) {
          checkMsg = FbaJobConstants.VERIFY_STATE_REVIEWED.chineseName
        }
      }
      if (checkMsg) {
        this.$message.warning(checkMsg + '的业务不能编辑')
        return
      }
      this.detailHandle('edit', row)
    },
    /**
     * 详情复制的话 curRow 有值
     * @param curRow
     */
    toCopy(curRow) {
      if (JobUtils.checkHQ()) {
        return
      }
      const row = curRow || this.$refs.orderGrid.selectedItem
      if (row.customerId) {
        this.loading = getLoading()
        isContractExpiredForbidCreateJob(row.customerId).then(res => {
          this.loading.close()
          if (res.data) {
            this.$message.warning(this.$t('Message.ContractExpireCannotCreated'))
          } else {
            this.copyDialog.job = row
            const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_fba') // 是否显示复制选项弹框【勾选是true不显示】
            if (!isShowView) {
              this.copyDialog.visible = true
            } else {
              this.doCopyJob()
            }
          }
        })
      }
    },
    doCopyJob() {
      const item = {}
      item.jobRule = ''
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      /* 复制哪些页签的数据 */
      item.vesselEq = false
      item.mbl = false
      item.hbl = false
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_fba')
      item.prePlanBooking = false
      item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUTfba')
      item.all = false
      this.loading = getLoading()
      doCopyFbaJob(item).then(async res => {
        const newJob = res.data
        newJob.opOffice = this.$store.getters.currentOfficeId
        newJob.copyNum = item.copyNum
        this.detailHandle('copy', newJob)
      }).finally(() => {
        this.loading.close()
      })
    },
    toAdd() {
      this.detailHandle('add', { uuid: '' })
      if (this.view === 'detail') {

      } else {
        this.view = 'detail'
      }
    },
    // 删除
    toDelete() {
      const selections = this.$refs.orderGrid.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      let states = true
      // 判断预审状态  待定
      const keys = []
      // 如果预审状态为暂不提交、已拒绝 提示错误信息
      selections.forEach(item => {
        // 判断提交状态为暂不提交 预审状态为已拒绝
        if (item.submitState !== 1 && item.verifyState !== 2) {
          states = false
          return
        }
        // 判断预审状态为已拒绝
        keys.push(item.uuid)
      })
      if (states) {
        this.$confirm(this.$t('CargoMsg.Cargo_DeleteConfirm'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          fbaBatchRemove(keys).then(res => {
            if (res.data) {
              if (selections && selections.length > 0) {
                for (const row of selections) {
                  const index = this.$refs.orderGrid.rowData.indexOf(row)
                  if (index !== -1) {
                    this.$refs.orderGrid.rowData.splice(index, 1)
                  }
                }
                this.$refs.orderGrid.gridOptions.api.refreshCells({ force: true })
              }
              // 刷新页面方法
              this.$message.success(this.$t('Message.DeleteSucceeded'))
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotSubmittedOrRejectedTips'))
        return
      }
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = []
      if (this.view !== 'detail') {
        this.view = 'detail'
        rowData = this.$refs.orderGrid.rowData
      } else {
        rowData = this.$refs.orderWorkspace.rowData
      }
      this.$refs.orderWorkspace.onShow(type, rowData, row)
    },
    backToList(isRefresh) {
      const rowData = this.$refs.orderWorkspace.rowData
      this.view = 'list'
      if (isRefresh) {
        this.$refs.orderGrid.toQueryList()
      } else {
        this.$refs.orderGrid.updateListData(rowData)
      }
    },
    // 暂不提交
    toNotSubmit(curRow) {
      const selections = curRow ? [curRow] : this.$refs.orderGrid.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Not_Submit_Please'))
        return
      }
      // 状态判断
      let states = true
      const keys = []
      selections.forEach(item => {
        // 判断预审状态为待审核
        if (item.verifyState === 0 && item.submitState !== 1) {
          keys.push(item.uuid)
        } else {
          states = false
          return
        }
      })
      if (states) {
        this.$confirm(this.$t('CargoMsg.Cargo_Not_Submit'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          updNotSubmitOrSubmit({ type: 'FBA_NOT_SUBMIT', keys: keys }).then(res => {
            if (res.data > 0) {
              this.$message.success(this.$t('CargoMsg.Cargo_Not_Submit_Batch_Success'))
            }
            if (curRow) {
              this.$refs.orderWorkspace.onRefresh()
            } else {
              this.$refs.orderGrid.toQueryList()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      } else {
        if (curRow) {
          this.$message.warning('只能处理暂不提交【待审核】的订单！')
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_Not_Approved'))
        }
        return
      }
    },
    // 提交
    toSubmit(curRow) {
      const selections = curRow ? [curRow] : this.$refs.orderGrid.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Submit_Batch'))
        return
      }
      // 状态判断
      let states = true
      const keys = []
      selections.forEach(item => {
        // 判断预审状态为待审核
        if (item.submitState === 1) {
          keys.push(item.uuid)
        } else {
          states = false
          return
        }
      })
      if (states) {
        this.$confirm(this.$t('CargoMsg.Cargo_Submit_Pre_Qualification'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          updNotSubmitOrSubmit({ type: 'FBA_SUBMIT', keys: keys }).then(res => {
            // 刷新页面方法
            if (res.data > 0) {
              this.$message.success(this.$t('CargoMsg.Cargo_Submit_Success'))
            }
            if (curRow) { // 刷新详情
              this.$refs.orderWorkspace.onRefresh()
            } else {
              this.$refs.orderGrid.toQueryList()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_Submit_Job'))
        return
      }
    },
    // 导入下单
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case '货物信息导入':
          this.$refs.uploadOrder.submit()
          break
        case '下载模版':
          this.downloadTemplate()
          break
        case '导入一个FBA订单':
          this.$refs.uploadOrderSingle.submit()
          break
        case '下载模版 ':
          this.downloadTemplateSingle()
          break
      }
    },

    downloadTemplate() {

    },
    // 单个导入
    uploadOrderSuccessSingle(e) {
      const { data } = e
      this.loading.close()
      this.$confirm(data.message, this.$t('queryJob.uploadSucceeded'), {
        cancelButtonText: this.$t('Partners.downloadImportResults'),
        confirmButtonText: this.$t('Message.Confirm'),
        distinguishCancelAndClose: true,
        beforeClose: async(action, instance, done) => {
          if (action === 'cancel') {
            await cache.load(cacheName.USER, cacheName.CONFIG)
            // const storageUrl = cache.config.get('StorageURL')
            const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
          } else {
            done()
          }
        }
      })
    },
    // 批量导入
    uploadOrderSuccessBatch(res, file, fileList) {
      this.loading.close()
      if (res.ok) {
        const h = this.$createElement
        this.$msgbox({
          title: this.$t('common.tips.prompt'),
          message: h('p', null, [
            h('p', { style: 'fontSize: 20px;paddingBottom:5px' }, this.$t('CargoMsg.Cargo_ImportingData')),
            h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
          ]),
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'success'
        })
      } else {
        this.$confirm(res.message, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          canCloseModule: true,
          type: 'warning'
        })
      }
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    beforeOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    downloadTemplateSingle() {
      ExportUtils.downloadTemplateFile('ImportOneFbaOrder.xlsx', 'fba')
    },
    downloadBatchTemplateSingle() {
      // ExportUtils.downloadTemplateFile('ImportBatchFbaOrders.xlsx', 'fba')
      ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'FBA')
    }

  }

}
</script>

<style lang="scss">
</style>
